import { put, select } from 'redux-saga/effects';
import {
  enqueueErrorSnackbar,
  enqueueSuccessSnackbar,
} from '../notifications/actionWrapper';

import api from '../utils/etrApi';
import { translate } from '../../utils/translation';
import { selectSelectedLanguage } from '../userData/selectors';

export function fetchFinancialFramesSagaFactory(actions) {
  return function* () {
    const lang = yield select(selectSelectedLanguage);
    try {
      const { data } = yield api.get('ppm/financial-frames');
      if (data) {
        yield put(actions.fetchFinancialFramesSuccess(data));
      }
    } catch (e) {
      yield put(actions.fetchFinancialFramesError(e));
      yield put(
        enqueueErrorSnackbar(
          translate('snackbarMessages.couldNotFetchFinancialFrames', lang),
        ),
      );
    }
  };
}

export function updateFinancialFrameSagaFactory(actions) {
  return function* ({ payload }) {
    const lang = yield select(selectSelectedLanguage);
    try {
      yield api.put(`ppm/financial-frames/${payload.id}`, payload.body);
      yield put(actions.updateFinancialFrameSuccess(payload));
      yield put(
        enqueueSuccessSnackbar(
          translate('snackbarMessages.successfullyUpdatedFinancialFrame', lang),
        ),
      );
    } catch (e) {
      yield put(actions.updateFinancialFrameError(e));
      yield put(
        enqueueErrorSnackbar(
          translate('snackbarMessages.couldNotUpdateFinancialFrame', lang),
        ),
      );
    }
  };
}
